import { Link } from "react-router-dom";
import { PlayCircle, Lightbulb, CheckCircle2, ArrowRight } from "lucide-react";
import { useGuide } from "@/lib/guide";

export const ModuleView = ({ m, compact }) => {
  const { startTour, markDone, done, setOpen } = useGuide();
  const concrete = m.path && !m.path.endsWith("/");
  return (
    <article className="space-y-5" data-testid={`guide-module-${m.id}`}>
      <div>
        <h3 className={`font-display ${compact ? "text-3xl" : "text-4xl sm:text-5xl"}`}>{m.title}</h3>
        <p className="text-sm sm:text-base text-muted-foreground mt-2 leading-relaxed">{m.summary}</p>
        {m.who && <p className="font-mono text-[11px] text-[#00E5FF] mt-2">Who: {m.who}</p>}
      </div>
      <div className="flex flex-wrap gap-2">
        {m.tour?.length > 0 && <button onClick={() => startTour(m)} data-testid={`guide-start-tour-${m.id}`}
          className="inline-flex items-center gap-2 h-9 px-4 rounded-full bg-[#D4FF3A] text-black text-sm font-semibold hover:bg-[#e2ff73] transition-colors"><PlayCircle className="w-4 h-4" />Start tour</button>}
        {concrete && <Link to={m.path} onClick={() => setOpen(false)} className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full border border-white/15 text-sm hover:bg-white/5" data-testid={`guide-goto-${m.id}`}>Open page <ArrowRight className="w-3.5 h-3.5" /></Link>}
        <button onClick={() => markDone(m.id)} disabled={done.includes(m.id)} data-testid={`guide-done-${m.id}`}
          className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full border border-white/15 text-sm hover:bg-white/5 disabled:text-[#D4FF3A] disabled:border-[#D4FF3A]/40"><CheckCircle2 className="w-4 h-4" />{done.includes(m.id) ? "Learned" : "Mark as learned"}</button>
      </div>
      {m.concepts?.length > 0 && (
        <dl className="grid sm:grid-cols-2 gap-2">
          {m.concepts.map(([k, v]) => <div key={k} className="rounded-lg border border-white/[0.07] bg-white/[0.02] p-3"><dt className="text-sm font-medium">{k}</dt><dd className="text-xs text-muted-foreground mt-1 leading-relaxed">{v}</dd></div>)}
        </dl>
      )}
      {m.steps?.length > 0 && (
        <section><div className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-2">How to use it</div>
          <ol className="space-y-2.5">{m.steps.map((s, i) => (
            <li key={i} className="grid grid-cols-[26px_1fr] gap-3 text-sm"><span className="w-6 h-6 rounded-full border border-white/15 grid place-items-center font-mono text-[11px]">{i + 1}</span><span className="leading-relaxed">{s}</span></li>
          ))}</ol></section>
      )}
      {m.example && (
        <section className="rounded-xl border-l-2 border-[#00E5FF] bg-[#00E5FF]/[0.04] p-4" data-testid={`guide-example-${m.id}`}>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#00E5FF]">Example · {m.example.title}</div>
          <p className="text-sm mt-1.5 leading-relaxed">{m.example.body}</p>
        </section>
      )}
      {m.tips?.length > 0 && <ul className="space-y-1.5">{m.tips.map((t) => <li key={t} className="flex gap-2 text-xs text-muted-foreground"><Lightbulb className="w-3.5 h-3.5 text-[#FFB020] flex-shrink-0 mt-0.5" />{t}</li>)}</ul>}
    </article>
  );
};
